import { render, staticRenderFns } from "./SmsChannelstatistics.vue?vue&type=template&id=50785b07&scoped=true"
import script from "./SmsChannelstatistics.vue?vue&type=script&lang=js"
export * from "./SmsChannelstatistics.vue?vue&type=script&lang=js"
import style0 from "./SmsChannelstatistics.vue?vue&type=style&index=0&id=50785b07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50785b07",
  null
  
)

export default component.exports